import _ from 'lodash';

import { UNCATEGORIZED_LABEL } from './SubmissionReadinessPanel.constants';

export const groupMissingItemsByCategory = (missingItems = []) =>
  _.chain(missingItems)
    .groupBy(({ categoryLabel }) => categoryLabel || UNCATEGORIZED_LABEL)
    .toPairs()
    .map(([categoryLabel, items]) => ({ categoryLabel, items }))
    .value();
